import axios from 'axios';

import {
  ADD_ADVISION, GET_ERRORS
} from './types';
import { ToastContainer, toast } from 'react-toastify';

export const saveAdvision= data => dispatch => {
  axios
    .post('/api/advision/add', data)
    .then(res => {
      dispatch({
        type: ADD_ADVISION,
        payload: res.data
      })
      toast.success('Gửi thông tin đăng ký thành công.');
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};